import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { translate } from 'react-translate';
import { CardTitle } from 'reactstrap';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Container,
  Col,
  Input,
  Button,
} from 'reactstrap';

import { useForm } from 'react-hook-form';
import { useTranslate } from 'react-translate';
import * as yup from 'yup';
import AuthDoctorsService from 'services/AuthDoctorsService';
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import { actionSweetAlert } from 'store/actions/commonActions';
import { actionLogout } from 'store/actions/usersActions';

const EmailChangeVerificationPage = (props) => {
  const { t } = props;

  const { hash } = useParams();
  const dispatch = useDispatch();

  const [loading, isLoading] = useState(true);
  const [submitting, isSubmitting] = useState(false);
  const [hashInfo, setHashInfo] = useState([]);

  //Form logic
  const schema = yup.object().shape({
    password: yup.string().required(t('error-required-password')).min(6, t('error-required-length')),
  });

  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: 'onBlur',
  });

  const fetchToken = async (history, hashData) => {
    const res = await AuthDoctorsService.verifyHash(hashData[0], hashData[1], hashData[2]);
    if (!res || res.status >= 400) {
      history.replace("/auth/");
    } else {
      isLoading(false);
    }
  }

  useEffect(() => {
    if (hash) {

      const hashData = hash
      ? decodeURIComponent(escape(atob(hash))).split(':')
      : null;

      if (hashData) {
        setHashInfo(hashData);
        fetchToken(props.history, hashData);
      } else {
        history.replace("/auth/");
      }
    }
  }, [hash]);


  //User confirmed the operation
  const onSubmit = async (data) => {

    //Calling
    isSubmitting(true);

    const res = await AuthDoctorsService.confirmHashRequest(data.password, hashInfo[0], hashInfo[1], hashInfo[2]);
    if (!res || res.status >= 400) {
      toast.error("Error confirming the changes");
      console.log("Error");
      isSubmitting(false);
    } else {
      dispatch(actionLogout());
      props.history.replace("/auth/");
      isSubmitting(false);
    }
  }

  //User cancelled the operation
  const onConfirm = async () => {
    dispatch(actionSweetAlert(null)); 
    const res = await AuthDoctorsService.cancelHashRequest(hashInfo[0], hashInfo[1], hashInfo[2]);
    if (!res || res.status >= 400) {
      toast.error("Error confirming the changes");
      console.log("Error");
      isSubmitting(false);
    } else {
      props.history.replace("/auth/");
      isSubmitting(false);
    }
  };

  if (loading) {
    return <LoadingLocal />
  }

  const onCancelClick = async () => {
    dispatch(
      actionSweetAlert(
        <SweetAlert
          custom
          customIcon="/General/icons/warning-sign-orange.svg"
          title={t('are-you-sure-you-want-to-cancel')}
          onConfirm={onConfirm}
          customButtons={
            <>
              {/*Custom buttons for more control*/}
              <Button
                className="mb-3"
                color="info"
                size="lg"
                onClick={onConfirm}
              >
                {t('btn-yes')}
              </Button>

              <Button
                className="mb-3 ml-2"
                color="danger"
                size="lg"
                onClick={() => {
                  dispatch(actionSweetAlert(null)); 
                }}
              >
                {t('btn-no')}
              </Button>
            </>
          }
        ></SweetAlert>
      )
    );
  };

  return (
    <>
      <Container>
        <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
          <Card className="card-login card-plain">

            <form className="ds-auth__form" onSubmit={handleSubmit(onSubmit)}>

              <CardHeader className="login-title">
                <img src={'/General/login/logo.svg'} width="100%" alt="" />
                <CardTitle className="text-info">{t("email-update")}</CardTitle>
              </CardHeader>

              <CardBody>
                <p>{t("description")}</p>

                <Input
                  name="password"
                  type="password"
                  label={t('password-placeholder')}
                  placeholder={t('password-placeholder')}
                  innerRef={register}
                  error={errors.password?.message}
                />
              </CardBody>

              <CardFooter className="d-flex justify-content-between">
                <Button
                  type="submit"
                  color="info"
                  size="md"
                  disabled={submitting}
                >
                  {t('send-btn')}
                </Button>

                <Button
                  type="cancel"
                  color="primary"
                  size="md"
                  disabled={submitting}
                  onClick={(e) => {
                    e.preventDefault();
                    onCancelClick();
                  }}
                >
                  {t('cancel-btn')}
                </Button>
              </CardFooter>
            </form>
          </Card>
        </Col>
      </Container>
    </>
  );
};

export default translate('request-page')(EmailChangeVerificationPage);
